import React, { useEffect } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { MatcherReferralForm } from '../../experiment/TaxProMatcher/MatcherReferralForm';
import { MatcherContextProvider } from '../../experiment/TaxProMatcher/context';
import { getAuthenticationTaggedUrl, recaptchaKeyV3 } from '../../shared/utils';
import { trackPageViewed } from '../../shared/analytics';

function useTrackMatcherPageViewed() {
  useEffect(() => {
    getAuthenticationTaggedUrl().then((url) => {
      trackPageViewed({
        name: 'tax_pro_matcher_form',
        title: 'RamseyTrusted Tax Pro Matcher | RamseySolutions.com',
        keywords: ['tax', 'matcher', 'form'],
        referrer: document.referrer || undefined,
        ...(url ? { url } : {})
      });
    });
  }, []);
}

function App() {
  useTrackMatcherPageViewed();

  return (
    <React.StrictMode>
      <GoogleReCaptchaProvider reCaptchaKey={recaptchaKeyV3()}>
        <MatcherContextProvider>
          <MatcherReferralForm />
        </MatcherContextProvider>
      </GoogleReCaptchaProvider>
    </React.StrictMode>
  );
}

export { App };
